module.exports = __webpack_public_path__ + "media/images/logo/logo-white-horizontal-1bdb15a9c4d3e35732357ae429ea9c78.svg";